import { SvgIconProps } from '@mui/material';
import FeastPercentOffFoodPromoImage from 'assets/images/feast-percent-off-promo.png';

interface PercentOffFoodVoucherCircleProps extends SvgIconProps {
  width?: string;
  height?: string;
}

const PercentOffFoodVoucherCircle = ({
  height = '106',
  width = '116',
}: PercentOffFoodVoucherCircleProps) => (
  <img
    width={width}
    height={height}
    src={FeastPercentOffFoodPromoImage}
    alt="25% off food ends this week!"
  />
);

export default PercentOffFoodVoucherCircle;
